<template>
  <b-form>
    <b-row>
      <b-col>
        <b-form-group
          id="fieldsetIsPendingInactive"
          :label-cols="4"
          breakpoint="md"
          label="Inactivate Pharmacy:"
          label-for="radio-pending-inactivate"
        >
          <b-form-radio-group
            id="radio-pending-inactivate"
            v-model="pharmacy.is_pending_inactivation"
            name="radio-pending-inactivate"
            :disabled="isReadonly"
          >
            <b-form-radio :value="true">Yes</b-form-radio>
            <b-form-radio :value="false">No</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group
          id="fieldsetName"
          :label-cols="4"
          breakpoint="md"
          label="Name*:"
          label-for="inputName"
        >
          <b-form-input
            id="inputName"
            name="inputName"
            v-validate="'required|max:100'"
            type="text"
            v-model="pharmacy.file_source_name"
            :rows="4"
            data-vv-as="Name"
            placeholder="Name"
            :disabled="isReadonly"
          ></b-form-input>
          <span class="text-danger">{{ errors.first('inputName') }}</span>
        </b-form-group>
      </b-col>
    </b-row>
    <VCopayEPARetrySetting :entity="pharmacy" :isReadonly="isReadonly" ref="pharmacyRetrySettingRef"></VCopayEPARetrySetting>
    <b-row>
      <b-col>
        <b-form-group
          id="fieldsetHasHeader"
          :label-cols="4"
          breakpoint="md"
          label="Has Header:"
          label-for="inputHasHeader"
        >
          <b-form-radio-group
            id="radio-has-header"
            v-model="pharmacy.has_header"
            name="radio-has-header"
            :disabled="isReadonly"
          >
            <b-form-radio :value="true">Yes</b-form-radio>
            <b-form-radio :value="false">No</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group
          id="fieldsetParser"
          :label-cols="4"
          breakpoint="md"
          label="Parser*:"
          label-for="selectParser"
        >
          <b-form-select
            id="selectParser"
            name="selectParser"
            v-model="pharmacy.parser"
            v-validate="'required'"
            data-vv-as="Parser"
            placeholder="Parser"
            :disabled="isReadonly"
          >
            <option :value="null">Please select a parser</option>
            <option value="AllFieldsParser">All Fields</option>
            <option value="HorizonPineRidgeParser">Pine Ridge</option>
            <option value="HorizonHighlandParser">Highland</option>
            <option value="CustomParser">Custom</option>
          </b-form-select>
          <span class="text-danger">{{ errors.first('selectParser') }}</span>
        </b-form-group>
      </b-col>
    </b-row>
    <div v-show="pharmacy.parser === 'CustomParser'">
      <VCopayEPAFileParser :entity="pharmacy" :isReadonly="isReadonly" ref="pharmacyItemFileParserRef"></VCopayEPAFileParser>
    </div>
  </b-form>
</template>
<script>
  import VCopayEPARetrySetting from "@/components/VCopayEPARetrySetting";
  import VCopayEPAFileParser from "@/components/VCopayEPAFileParser";

  // @ts-check
  export default {
    name: "VCopayEPAPharmacyItem",
    components: {
      VCopayEPARetrySetting,
      VCopayEPAFileParser
    },
    props: {
      pharmacy: {
        required: true,
        type: Object
      },
      isReadonly: {
        required: false,
        type: Boolean
      }
    }
  };
</script>

<style>
  #radio-has-header {
    padding-left: 20px;
  }
  #radio-has-header label {
    padding-right: 10px;
  }
  #radio-pending-inactivate {
    padding-left: 20px;
  }
  #radio-pending-inactivate label {
    padding-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/VCopayEPAPharmacyItem.vue